<template>
  <b-table :data="freight"
           striped
           hoverable
           detailed
           detailed-key="companyJobFreightKey">
    <template slot-scope="props">
      <b-table-column field="companyJobFreightDescription" label="Description">
        {{ props.row.companyJobFreightDescription }}
      </b-table-column>
      <b-table-column field="companyJobFreightPallets" label="Pallet Count" >
        {{ props.row.companyJobFreightPallets }}
      </b-table-column>

      <b-table-column field="origin.facilityName" label="Origin" >
        <template v-if="props.row.origin">
        {{ props.row.origin.facilityName }} <br/>
        {{ props.row.origin.street1 }} <br/>
        {{ props.row.origin.city }} {{ props.row.origin.state }}, {{ props.row.origin.zip }}
        </template>
        <template v-else>
          N/A
        </template>
      </b-table-column>
      <b-table-column field="destination.facilityName" label="Destination" >
        <template v-if="props.row.destination">
        {{ props.row.destination.facilityName }} <br/>
        {{ props.row.destination.street1 }} <br/>
        {{ props.row.destination.city }} {{ props.row.destination.state }}, {{ props.row.destination.zip }}
        </template>
        <template v-else>
          N/A
        </template>
      </b-table-column>
    </template>

    <template slot="detail" slot-scope="props">
      <div class="columns is-multiline details">
        <dl class="column floated-list">
          <dt>Quantity</dt>
          <dd> {{ props.row.companyJobFreightQuantity }}  </dd>

          <dt>Weight</dt>
          <dd> {{ formatWeight(props.row.companyJobFreightWeight) }} </dd>

          <dt>Dimensions (inches)</dt>
          <dd> {{ formatDimensions(props.row.companyJobFreightKey) }} </dd>
        </dl>

        <dl class="column floated-list">

          <dt>Packaging</dt>
          <dd> {{ props.row.companyJobFreightPackagingType }} </dd>

          <dt>Category</dt>
          <dd> {{ props.row.companyJobFreightCategory }} </dd>

          <dt>HazMat</dt>
          <dd> {{ props.row.companyJobFreightHazmatcode }} </dd>
        </dl>

        <div class="column is-full">
          <dl>
            <dt>
              Comments
            </dt>
            <dd>
              {{ props.row.companyJobFreightComments }}
            </dd>
          </dl>
        </div>
      </div>
    </template>
  </b-table>
</template>

<script>
import Numeral from 'numeral'
export default {
  name: 'FreightInformation',
  props: {
    freight: {
      type: Array,
      required: true
    }
  },

  methods: {
    formatDimensions(companyJobFreightKey) {
      const lineItem = this.freight.find((lineItem) => lineItem.companyJobFreightKey === companyJobFreightKey)
      let formattedValue = ''
      if (
        lineItem.companyJobFreightDimensionLength &&
        lineItem.companyJobFreightDimensionHeight &&
        lineItem.companyJobFreightDimensionWidth
      ) {
        formattedValue = `${lineItem.companyJobFreightDimensionLength}L x ${
          lineItem.companyJobFreightDimensionHeight
        }H x ${lineItem.companyJobFreightDimensionWidth}W`
      }

      return formattedValue
    },

    formatWeight(weight) {
      let formattedValue = ''
      if (weight) {
        formattedValue = `${Numeral(weight).format('0,0')} lbs`
      }

      return formattedValue
    }
  }
}
</script>

<style scoped lang="scss">
</style>
